import type { FaireProductEntity } from "../../entity_types/product";

export const p_93whrnags3: FaireProductEntity = {
  token: "p_93whrnags3",
  type: "product",
  name: "Baby Girls Spring Pink Flowers Long Sleeve Hooded Zip Jacket Cardigan Tops",
  brandToken: "b_tbys5jk9cz",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0fc6af3ca676d4a0a942a997ccbba44ddc9fe450f09b44fc79b5e243c048171e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/caf437aa01dcfd509714f296a2985b628cf077e4107d04d1e602fdf7d7cc0fd2.jpeg",
    "https://cdn.faire.com/fastly/dbd2d7a666c8a439965835ae17ba32e953a14a3df262f4bc871ad8801501e61a.jpeg",
  ],
  priceDollars: 15.25,
  description:
    "\nMaterial:milk silk,soft and stretchy\n\nReady to ship\n\nMade in China\n\nShip from China\n\nThe item is ready to ship now,our sizes are true to size.We have been making kids boutique clothing for 12years .\nShipping time:2-4days after order and about 8-12days delivery time.\n\nIf you have any problem with order,please contact me directly,we will do best to help solve~\n",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:00.231Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
